export class IndividualInterestTypeReferenceModel {
    public individualInterestTypeCode: string;
    public individualInterestTypeName: string;
    public sortSequence: number;
}